import styled from 'styled-components';

export const Wrapper = styled.div`
  .button-update {
    float: right;
    color: #ffffff;
  }
`;
